//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import footerBar from "../components/footerBar";
import loginModle from "../components/loginModle";
import utils from "../JS/utils";
import ajax from "../JS/ajax";
import { eventBus } from "../main";

var qs = require("qs");

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: { footerBar, swiper, swiperSlide, loginModle },
  data() {
    return {
      scrollPosition: 0,//滚动位置
      swiperOption: {
        loop: true,
        initialSlide: 0,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        preventLinksPropagation: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: false, //允许分页点击跳转
        },
        on: {
          click: (swiper) => {
            let type = swiper.target.getAttribute('data-type');
            let target = swiper.target.getAttribute('data-target');
            this.towebview(type, target)
          }
        }
      },
      swiperOption2: {
        loop: false,
        height: "180px",
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      ary: [],
      bannerImg: [],
      filterArr: [],
      ext: [],
      service_items: [],
      position: "",
      top: false,
      nav: true,
      load: false,
      sortList: [],
      type: '',
      filterArr3: [],
      msg: {
        isShow: false,
        page: '',
        code: utils.queryParse(location.href).code || "",
        bindphone: false,
        bindphone2: false
      },
      channel: utils.channel,
      footerShow: {
        "name": "index"
      },
      searchtext: '搜索服务、技师、商家',
      delayRender: false,// 延迟渲染显示
    };
  },
  /**
   * 到达页面时触发
   * @param {Object} to
   * @param {Object} from
   * @param {Object} next
   */
  beforeRouteEnter(to, from, next) {
    to.meta.fromPath = from.path;
    next((vm) => {
      vm.page = from.path;
    });
  },
  /**
   * 页面激活时触发
   */
  activated() {
    document.title = "到位·上门服务";
    var that = this;
    // 增加延迟是为了不让页面同一时间渲染图片(苹果百度浏览器有崩溃的可能性，点击上一页会直接返回到百度首页)
    setTimeout(function(){
      that.delayRender = true;// 延迟渲染显示
    }, 100);
    var locationurl = utils.queryParse(location.href);
    var fromPath = that.$route.meta.fromPath;
    that.userId = localStorage.getItem("userId");
    var position = localStorage.getItem("position") ? JSON.parse(localStorage.getItem("position")) : '';
    if (position && position != "null" && position != null) {
      if (that.position.name != position.name) {
        that.position = position;
        that.getbanner();//首页横幅
        that.getFilter();//首页导航
        that.getItems();//首页服务分类
        that.getList("", 0, "fast");
      }
    } else {
      this.load = true;
      this.getlocation();
    }
    if (fromPath == "/zhiyue" || fromPath == "/allorder" || fromPath == "/my") {
      // 滚动到指定位置
      setTimeout(function() {
        if (that.scrollPosition) {
          window.scrollTo(0, that.scrollPosition);
        }
      }, 10);
    }
    // 未登录情况
    var url = "/";
    var params = "";
    for (var param in locationurl) {
      if (param != "code") {
        params += "&" + param + "=" + locationurl[param];
      }
    }
    if (params != "") {
      url += "?" + params.substring(1, params.length);
    }
    if (!that.userId && utils.isWeiXin()) {
      that.msg.isShow = true;
      that.msg.page = url;
    }
    // if (!that.userId && utils.isWeiXin()) {
    //   if (!locationurl.code) {
    //     that.msg.isShow = true;
    //     that.msg.page = url;
    //   } else {
    //     setTimeout(function() {
    //       if (!that.userId) {
    //         that.msg.isShow = true;
    //         that.msg.page = url;
    //       }
    //     }, 1500);
    //   }
    // }
  },
  /**
   * 离开页面时触发
   */
  beforeRouteLeave(to, from, next) {
    var that = this;
    var scroller = window.scrollY || window.pageYOffset;
    that.scrollPosition = scroller;
    next((vm) => {});
  },
  created() {
    this.$bus.$on('updateVariableEvent', item => {
      this.position.name = item.name;
      this.position.city = item.city;
    });
  },
  mounted() {
    var that = this;
    document.title = "到位·上门服务";
    var locationurl = utils.queryParse(location.href);
    var userId = localStorage.getItem("userId");
    this.userId = userId;
    if (locationurl.channel) {
      sessionStorage.setItem('channel', locationurl.channel)
      this.channel = locationurl.channel;
      utils.channel = locationurl.channel;
    }
    var channel = sessionStorage.getItem('channel');
    if (locationurl.channel == 'lingxi' || channel == 'lingxi') {
      this.footerShow.name = "other";
      this.channel = locationurl.channel || channel;
      utils.channel = locationurl.channel || channel;
      document.title = "到位·灵锡到家";
      this.searchtext = '搜索服务';
      this.getInitCode();
    }
    if (locationurl.inviter) {
      sessionStorage.setItem('inviter', inviter)
    }
    if (locationurl.phone && locationurl.sign) {
      utils.channelogin(
        locationurl.phone,
        locationurl.sign,
        locationurl.channel || channel,
        utils.inviter
      );
    } else {
      utils.loginname();
    }
    if (locationurl.top != 0 || utils.top) {
      utils.top = true;
      this.top = true;
    }
    if (locationurl.nav == 0) {
      utils.nav = false;
      this.nav = false;
    }
    if (locationurl.lng && locationurl.lat) {
      this.getCommunity(locationurl.lng, locationurl.lat);
    } else {
      var position = localStorage.getItem("position");
      if (position && position != null) {
        // alert("有缓存数据，直接显示");
        console.log("有缓存2：");
        that.position = JSON.parse(position);
        this.getbanner();//首页横幅
        this.getFilter();//首页导航
        this.getItems();//首页服务分类
        this.getList();//首页推荐技师列表
      } else {
        // alert("没有缓存数据，先显示内容");
        this.getbanner();//首页横幅
        this.getFilter();//首页导航
        this.getItems();//首页服务分类
        this.getList();//首页推荐技师列表
        this.getlocation();
      }
    }
    utils.setwxConfig();
    if (locationurl.phone && locationurl.sign) {
      utils.channelogin(locationurl.phone, locationurl.sign, locationurl.channel, (locationurl.inviter || ''))
    }
    // 未登录情况
    var url = "/";
    var params = "";
    for (var param in locationurl) {
      if (param != "code") {
        params += "&" + param + "=" + locationurl[param];
      }
    }
    if (params != "") {
      url += "?" + params.substring(1, params.length);
    }
    if (!that.userId && utils.isWeiXin()) {
      that.msg.isShow = true;
      that.msg.page = url;
    }
    // if (!that.userId && utils.isWeiXin()) {
    //   if (!locationurl.code) {
    //     that.msg.isShow = true;
    //     that.msg.page = url;
    //   } else {
    //     setTimeout(function() {
    //       if (!that.userId) {
    //         that.msg.isShow = true;
    //         that.msg.page = url;
    //       }
    //     }, 1500);
    //   }
    // }
  },
  methods: {
    updatePositionInfo(item){
      // alert("局部刷新");
      this.position.name = item.name;
      this.position.city = item.city;
      this.getList();//刷新附近技师
    },
    fatherMethod(userId) {
      this.userId = userId;
    },
    getInitCode() {
      var that = this;
      var url = "/daoway/rest/lingxi/initCode";
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var initCode = result.initCode;
            //that.setCode2();
            ls.config({
              debug: false, //开发时建议把调试模式开启
              appId: 'B942623720220032T', //从开放平台申请到的 appId
              initCode: initCode //从业务方自己后台请求到 initCode
            });
            ls.ready(function () {
              //自定义逻辑，如：
              //1.调用 JSSDK 里提供的交互方法
              //2.如需获取用户信息，需要在此处调用 ls.userAuth(Objectobject)方法获取requestCode。
              //  userAuth根据appid会自动判断是否需要登录、认证和授权。
              ls.userAuth({
                appId: 'B942623720220032T', //从开放平台申请到的 appId
              }, function (res) {
                if (res.code === 200) {
                  let requestCode = res.data.requestCode; //获取到requestcode
                  that.setCode(requestCode)
                } else if (res.code === 9005) {
                  window.setTimeout(() => {
                    ls.close()
                  }, 500);
                  // 认证失败或登录失败
                  //console.log('认证失败或登录失败')
                  alert('认证失败或登录失败,重新登录')
                  that.getInitCode()
                  // 如果在此处调用ls.close()关闭页面,需要延迟0.5秒执行，否则ls.close()会无效。
                } else {
                  window.setTimeout(() => {
                    ls.close()
                  }, 500);
                  // 其余情况
                  alert('认证失败或登录失败,重新登录')
                  //alert('userAuth error')
                  that.getInitCode()
                  // 如果在此处调用ls.close()关闭页面,需要延迟0.5秒执行，否则ls.close()会无效。
                }
              });
            });
            ls.error(function (res) {
              console.log(res)
              that.getInitCode()
              //错误处理
            });
          }
        });
    },
    setCode(code) {
      var that = this;
      var url = "/daoway/rest/users/login_lingxi";
      ajax
        .post(url, qs.stringify({ 'requestCode': code }), {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            localStorage.setItem("nick", data.nick);
            if (data.phone != undefined && data.phone != null) {
              localStorage.setItem("phone", data.phone);
            } else {
              localStorage.setItem("phone", "");
            }
            localStorage.setItem("userId", data.userId);
            that.getdwvip(data.userId);
          }
        })
    },
    getdwvip(userId) {
      var that = this;
      var url =
        "/daoway/rest/vip/" + userId + "/my_vip?channel=" + utils.channel;
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            var dwVip = data.dwVip;
            if (dwVip) {
              localStorage.setItem("dwVip", dwVip);
            }
          }
        });
    },
    toposition() {
      this.$router.push({
        path: "/position?page=index",
      });
    },
    toUrls(i) {
      // alert("进入详情页");
      var url = "/search_service?filter=" + i.id;
      if (i.subCategory) {
        url += "&tag=" + encodeURIComponent(i.name);
      }
      // this.$router.replace({
      this.$router.push({
        path: url
      });
    },
    toUrls2(i) {
      var pathurl = i.url;
      var id = i.id;
      var name = i.name;
      var url = '';
      if (pathurl && pathurl.indexOf('detail') > -1) {
        var temp = pathurl.split("item/");
        url = "/detail?priceId=" + temp[1] + "&entry=banner"
      } else {
        url = "/search_service?filter=" + id;
        if (name) {
          url += '&tag=' + name;
        }
      }
      this.$router.push({
        path: url,
      });
    },
    toUrl(i) {
      var url = "/search_service?filter=" + i;
      // alert(url);
      this.$router.push({
        path: url,
      });
    },
    todetail(id) {
      utils.entry = "classlist";
      this.$router.push({
        path: "/detail?priceId=" + id,
      });
    },
    tozhiyue() {
      this.$router.push({
        path: "/zhiyue",
      });
    },
    //点击进入技师详情页面，跳转
    goTechniciandetailPage(dwid, index) {
      var that = this;
      //'&fromTechnician=index';//解决页面缓存，没有数据时报错的问题
      var category = that.category || '';
      var url = "/techniciandetail?dwid=" + dwid + "&category=22&nub=" + (index + 1) +'&fromTechnician=index';
      if (!that.userId) {
        if (utils.isWeiXin()) {
          that.msg.isShow = true;
          that.msg.page = url;
        } else {
          that.msg.bindphone = true;
          that.msg.page = url;
        }
        return;
      }
      // 微信登录后未绑定手机号
      if (that.userId && utils.isWeiXin() && !localStorage.getItem("phone")) {
        that.msg.bindphone2 = true;
        return;
      }
      that.$router.push({
        path: url,
      });
    },
    getList() {
      var that = this;
      that.sortList = [];
      var url = "/daoway/rest/technicians/v3/nearby/list?size=10&start=0" + "&channel=" + this.channel + "&sortBy=fast";
      if (that.userId) {
        url += "&userId=" + that.userId;
      }
      var position = that.position;
      if (position) {
        if (position.city) {
          url += "&city=" + encodeURIComponent(position.city);
        }
        if (position.lng || position.lot) {
          url += "&lng=" + (position.lng || position.lot);
        }
        if (position.lat) {
          url += "&lat=" + position.lat;
        }
      }
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var datas = result.data;
            // alert("刷新附近技师");
            if (datas.length > 0) {
              var li = [];
              that.sortList = datas.slice(0, 10);
              var sortList = that.sortList;
              for (var i = 0; i < sortList.length; i++) {
                var obj = {
                  dwid:sortList[i].dwid
                }
                li.push(obj)
              }
              sessionStorage.setItem("sortList", JSON.stringify(li));
            }
          }
        });
    },
    getbanner() {
      var that = this;
      var position = that.position;
      var url = "/daoway/rest/config/banners?channel=" + utils.channel;
      if (position.city) {
        url += "&city=" + position.city;
      }
      if (position.id || position.communityId) {
        url += "&community_id=" + (position.id || position.communityId);
      }
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                data[i].img = data[i].imgUrl;
              }
              that.bannerImg = data;
            } else {
              if (utils.channel != 'lingxi') {
                that.bannerImg = [
                  { imgUrl: require("../assets/images/bannerdefault.jpg") },
                ];
              }

            }
          }
        });
    },
    getFilter() {
      var that = this;
      var position = that.position;
      var url =
        "/daoway/rest/category/for_filter?&weidian=false&recommendOnly=true&includeChaoshi=false&includeSecondPage=true&hasChaoshi=false&includeExtCategory=true&channel=" +
        this.channel;
      if (position) {
        url += "&manualCity=" + position.city;
      }
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            var extCategory = result.extCategory
            if (utils.channel == "nidian" || utils.channel == "qingsongdian") {
              var myext = [
                {
                  id: "22",
                  name: "中医推拿",
                  iconUrl2: "https://img.daoway.cn/img/tags/zhongyituina.png",
                  subCategory: true,
                },
                {
                  id: "22",
                  name: "油压SPA",
                  iconUrl2: "https://img.daoway.cn/img/tags/youya-spa.png",
                  subCategory: true,
                },
                {
                  id: "22",
                  name: "局部理疗",
                  iconUrl2: "https://img.daoway.cn/img/tags/jubuliliao.png",
                  subCategory: true,
                },
                {
                  id: "22",
                  name: "足疗套餐",
                  iconUrl2: "https://img.daoway.cn/img/tags/zuliaotaocan.png",
                  subCategory: true,
                },
                {
                  id: "22",
                  name: "产后修复",
                  iconUrl2: "https://img.daoway.cn/img/tags/chanhouhuli.png",
                  subCategory: true,
                },
              ];
              that.ext = myext;
            } else {
              that.ext = result.ext;
            }
            var ary = [];
            var ary1 = null;
            if (this.channel == 'lingxi') {
              ary1 = data.slice(0, 5);
            } else {
              ary1 = data.slice(0, 10);
            }
            ary.push(ary1);
            that.ary = ary;
            that.filterArr3 = extCategory;
            that.filterArr = data.splice(0, 10);
          }
        });
    },
    // 获取服务项目分类
    getItems() {
      var that = this;
      that.load = true
      var url = "/daoway/rest/service_items/recommend_top?start=0&size=30&includeNotInScope=true&channel=" + this.channel;
      if (that.position) {
        if (that.position.city) {
          url += "&manualCity=" + that.position.city;
        }
        if (that.position.lot || that.position.lng) {
          url +=
            "&lot=" +
            (that.position.lot || that.position.lng) +
            "&lat=" +
            that.position.lat;
        }
      }
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            that.service_items = data;
            console.log("服务内容：");
            console.log(data);
          }
          that.load = false;
        });
    },
    toindex() {
      this.$router.push({
        path: "/",
      });
    },
    tosearch() {
      this.$router.push({
        path: "/search",
      });
    },
    towebview(type, target) {
      // return
      var that = this;
      var url = "";
      //var userId = localStorage.getItem("userId");
      // if(userId == '437fdedd8ad34e78a1e7bdbb30edcd97'){
      //   alert(11)
      // }
      if (type == "service") {
        var url = "/detailspage?id=" + target;
      } else if (/openSuper/g.test(target)) {
        var code = /(\d+)/g.exec(target)[1];
        url += "/detail?priceId=" + code + "&entry=banner";
      } else if (/entrance/g.test(target)) {
        var temp = target.split("?tag=");
        var tagName = temp[1];
        var catId = temp[0].split("app://entrance/openService/")[1];
        var url = "/search_service?filter=" + catId + "&entry=banner";
        if (tagName) {
          url += "&tag=" + encodeURIComponent(tagName);
        }
      } else {
        console.log(target)
        var url = target + "&channel=" + utils.channel;
        if (that.position && that.position.city) {
          url += "&city=" + encodeURIComponent(that.position.city);
        }
        var userId = localStorage.getItem("userId");
        if (userId) {
          url += "&userId=" + userId
        }
        window.location.href = url;
        return;
      }
      this.$router.push({
        path: url,
      });
    },
    getlocation() {
      // alert("启动首页定位");
      var that = this;
      that.ipposition();
      var geolocation = new BMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过3秒后停止定位，默认：无穷大
        maximumAge: 0, //定位结果缓存0毫秒，默认：0
      });
      that.load = true;
      geolocation.getCurrentPosition(
        function (r) { // 成功的回调
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var point = r.point;
            utils.current = { lng: point.lng, lat: point.lat };
            console.log("无缓存，定位坐标");
            console.log(point);
            that.getCommunity(point.lng, point.lat);//查到位接口后加到缓存
          } else {
            that.ipposition()
          }
        },
        function (error) { // 失败的回调
          that.ipposition()
      })
    },
    ipposition() {
      var that = this;
      var url =
        "/daoway/rest/user/city?h5=1";
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status == 'ok') {
            var datas = result.data;
            if (datas && datas.community && datas.community.length > 0) {
              var position = datas.community[0];
              that.manualCity = position.city;
              // localStorage.setItem("position", JSON.stringify(position));
              that.position = position;
              that.getbanner();
              that.getFilter();
              that.getItems();
              that.getList("", 0, "fast");
              that.load = false;
            }
          }
        })
    },
    getCommunity(lng, lat) {
      var that = this;
      var url =
        "/daoway/rest/community/autoPositionMerge?lot=" +
        lng +
        "&lat=" +
        lat +
        "&channel=" +
        this.channel;
        console.log(url);
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            var item = [];//返回结果
            var city = "";
            if (data.parent) {
              city = data.parent.city;
              item = data.parent;
            } else if (data.communities && data.communities.length > 0) {
              city = data.communities[0].city;
              item = data.communities[0];
            }
            that.manualCity = city;
            that.community = data.communities;
            // localStorage.setItem("position", JSON.stringify(data.communities[0]));
            // that.position = data.communities[0];
            that.position = item;//更新放在列表前
            that.getbanner();
            that.getFilter();
            that.getItems();
            this.getList("", 0, "fast");
            localStorage.setItem("position", JSON.stringify(item));//缓存数据

            // this.position.city = that.position.city;
            // this.position.name = that.position.name;
          }
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/index.vue